"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var group_1 = require("./group");
function groupRoute(location) {
    var _a = location.path, section = _a[0], groupId = _a[1], tab = _a[2];
    var activeTab = Object.values(group_1.Tab).includes(tab)
        ? tab
        : group_1.Tab.DISCUSSION;
    return {
        section: section,
        groupId: groupId,
        activeTab: activeTab,
    };
}
exports.groupRoute = groupRoute;
//# sourceMappingURL=routeParams.js.map